import React, { useCallback, useMemo } from 'react';
import { Pane, Flex } from '@leverege/ui-elements';
import { DetailUtil, ValueText } from '@leverege/ui-attributes';
import isEqual from 'fast-deep-equal';
import Model from "../model/CountAggTextViewModel.js";
import S from './CountAggTextView.css';
import { buildVariant } from "../../util/index.js";
import { AggClickActionFactory } from "../Factory.js";
import { LabelButton } from "./Util.js";
import { cleanFilter } from "../../actions/clickActions/Util.js";
import { AggFilterCreatorFactory } from "../../actions/clickActions/Factory.js";
import { FilterSourcesModel } from "../../../../filters/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function CountAggTextView(props) {
  const {
    value,
    data,
    className,
    queryModel,
    aggModel,
    context
  } = props;
  const {
    clientProps: {
      objectType,
      delegate,
      filters
    }
  } = context;
  let {
    variant
  } = props;
  variant = Model.getVariant(value) || variant;
  const metadatas = FilterSourcesModel.getMetadata(filters);
  const filter = metadatas?.filterBar?.filter;
  const clickDisabled = useMemo(() => {
    const action = AggClickActionFactory.get(queryModel);
    return action.handles ? !action.handles(data, {
      ...context,
      queryModel
    }) : false;
  }, [queryModel, context, data]);
  const onClickCount = useCallback(({
    data,
    value
  }) => {
    const action = AggClickActionFactory.get(value ? queryModel : 'aggregation.noFilter');
    action?.onClick(data, {
      ...context,
      queryModel
    });
  }, [queryModel, context]);
  const isFiltered = useMemo(() => {
    const possibleFilter = cleanFilter(AggFilterCreatorFactory.create(aggModel.type, null, {
      queryModel,
      objectType,
      delegate,
      context: context?.clientProps
    })?.metadata?.filter?.rootCondition);
    const currentFilter = cleanFilter(filter?.rootCondition);
    if (possibleFilter && currentFilter) {
      return isEqual(possibleFilter, currentFilter);
    }
    return false;
  }, [aggModel, context, delegate, objectType, queryModel, filter]);
  if (!data) {
    return null;
  }
  const hLStyle = DetailUtil.getStyle(value?.header?.label);
  const vTStyle = DetailUtil.getStyle(value?.value?.text);
  return /*#__PURE__*/_jsx(Pane, {
    variant: buildVariant(variant, 'Item'),
    className: className,
    children: /*#__PURE__*/_jsxs(Flex, {
      className: S.container,
      variant: buildVariant(variant, 'ContainerFlex', 'colMStart'),
      children: [Model.getHeaderLabelVisible(value) && Model.getHeaderLabel(value) && /*#__PURE__*/_jsx(LabelButton, {
        disabled: clickDisabled,
        title: "Apply Filter",
        onChange: onClickCount,
        variant: buildVariant(variant, 'Title'),
        style: hLStyle,
        value: isFiltered,
        children: Model.getHeaderLabel(value)
      }), /*#__PURE__*/_jsx(ValueText, {
        variant: buildVariant(variant, 'Value'),
        style: vTStyle,
        children: data.count
      })]
    })
  });
}